import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles({
  card: {
    position: "relative",

    height: "100%",
    minHeight: 430,

    padding: 35,

    boxSizing: "border-box",

    borderRadius: 20,

    background: "rgba(255, 255, 255, 0.045)",

    border: "1px solid rgba(255, 255, 255, 0.08)",

    display: "flex",
    flexDirection: "column",

    overflow: "hidden",

    transition: "all 0.3s ease",

    "&:hover": {
      borderColor: "rgba(255, 255, 255, 0.16)",

      boxShadow: "0 20px 50px rgba(0, 0, 0, 0.18)",
    },
  },

  accent: {
    position: "absolute",

    top: 0,
    left: 0,

    width: "100%",
    height: 4,
  },

  iconWrapper: {
    width: 75,
    height: 75,

    borderRadius: 18,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    marginBottom: 25,

    background: (props) => `${props.background}20`,
  },

  image: {
    width: 48,
    height: 48,

    objectFit: "contain",
  },

  heading: {
    color: "#fff",

    fontSize: 22,
    fontWeight: 700,

    margin: "0 0 15px",
  },

  paragraph: {
    color: "#aaa9bb",

    fontSize: 14,

    lineHeight: 1.8,

    margin: "0 0 25px",
  },

  technologies: {
    display: "flex",
    flexWrap: "wrap",

    gap: 7,

    marginTop: "auto",
  },

  chip: {
    height: 27,

    background: "rgba(255, 255, 255, 0.07)",

    color: "#c9c8d5",

    fontSize: 11,

    border: "1px solid rgba(255, 255, 255, 0.06)",
  },
});

export default function Cards(props) {
  const classes = useStyles(props);

  return (
    <div className={classes.card}>

      <div
        className={classes.accent}
        style={{ background: props.background }}
      />

      <div className={classes.iconWrapper}>

        <img
          className={classes.image}
          src={props.image}
          alt={props.heading}
        />

      </div>

      <h2 className={classes.heading}>
        {props.heading}
      </h2>

      <p className={classes.paragraph}>
        {props.para}
      </p>

      <div className={classes.technologies}>
        {props.tech.map((item) => (
          <Chip
            key={item}
            label={item}
            className={classes.chip}
          />
        ))}
      </div>

    </div>
  );
}